import { SvgIcon } from '@mui/material';
import React from 'react';

const ArrowReturnIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 16.1053H7L7 3.62842L10.59 7.02L12 5.68421L6 0L0 5.68421L1.41 7.02L5 3.62842L5 18H11V16.1053Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default ArrowReturnIcon;
